const initialState = {
    data: [],
  };
  
  const usersAllReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_USERS_ALL':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default usersAllReducer;